import React from 'react';
import Icon from '../../../components/AppIcon';

const IntegrationStatusPanel = ({ services = {} }) => {
  const integrations = [
    { key: 'supabase', name: 'Supabase Database', icon: 'Database', description: 'Backend database and authentication' },
    { key: 'auth', name: 'Authentication', icon: 'Shield', description: 'User authentication service' },
    { key: 'ai', name: 'AI Services (Lambda)', icon: 'Brain', description: 'OpenAI, Anthropic, Gemini via AWS Lambda' },
    { key: 'stripe', name: 'Stripe Payments', icon: 'CreditCard', description: 'Payment processing service' }
  ];

  const getStatusBadge = (status) => {
    switch (status) {
      case 'healthy': return <span className="text-xs bg-success/10 text-success px-2 py-0.5 rounded-full">Operational</span>;
      case 'degraded': return <span className="text-xs bg-warning/10 text-warning px-2 py-0.5 rounded-full">Degraded</span>;
      case 'error': return <span className="text-xs bg-destructive/10 text-destructive px-2 py-0.5 rounded-full">Error</span>;
      case 'not_configured': return <span className="text-xs bg-muted text-muted-foreground px-2 py-0.5 rounded-full">Not Configured</span>;
      default: return <span className="text-xs bg-muted text-muted-foreground px-2 py-0.5 rounded-full">Unknown</span>;
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <h3 className="text-lg font-semibold text-foreground mb-4">Integration Status</h3>
      <div className="space-y-3">
        {integrations?.map((integration) => {
          const serviceInfo = services?.[integration?.key] || {};
          return (
            <div key={integration?.key} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
              <div className="flex items-center space-x-3">
                <Icon name={integration?.icon} size={18} className="text-muted-foreground" />
                <div>
                  <p className="text-sm font-medium text-foreground">{integration?.name}</p>
                  <p className="text-xs text-muted-foreground">{serviceInfo?.message || integration?.description}</p>
                </div>
              </div>
              {getStatusBadge(serviceInfo?.status)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IntegrationStatusPanel;